(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-images-marqee"] && !window.DesignMode) return;
  try {
    "use strict";!function(){function t(){var e=document.querySelectorAll(".qq-images-marquee .QQ-JS-init-msg");e&&e.forEach(function(e){e.remove()})}var m,c,l;function n(){(m=document.getElementsByClassName("qq-images-marquee")).length&&function(){if(c=[],m.length)for(var e,t,i,o,n=0;n<m.length;n++)!function(n){e=m[n].id,t="qq"+e.replace("template--","").replace("shopify-section-","").replace("__",""),i=document.getElementById(t).getElementsByClassName("qq-marquee-images")[0],o=i.getElementsByClassName("qq-block-image"),c[n]=new Object,c[n].sectionID=t,c[n].wrapper=i,c[n].imgs=o,c[n].imgsCntr=0,[].forEach.call(o,function(e,t){e.complete?(c[n].imgsCntr++,a(n)):e.addEventListener("load",function(e){c[n].imgsCntr++,a(n)})})}(n);function a(e){c[e].imgsCntr==c[e].imgs.length&&r(c[e])}function r(n){var e=document.getElementById(n.sectionID).getElementsByClassName("qq-marquee-images").length,t=n.wrapper.offsetWidth;l=window.innerWidth;var i=Math.ceil(l/t)+1,o=1,a=!0;if(document.querySelector(":root").style.setProperty("--"+n.sectionID+"-imagesMarquee-length","-"+t+"px"),e<i?i-=e:i<=e&&(a=!1),1==a)for(;o<=i;){var r=n.wrapper.cloneNode(!0);n.wrapper.parentNode.append(r),[].forEach.call(r.getElementsByClassName("qq-block-image"),function(e,t){e.width=n.imgs[t].width,e.height=n.imgs[t].height}),o++}setTimeout(function(e){e.wrapper.parentNode.classList.add("qq-animate")},1e3,n)}var s;window.onresize=function(){clearTimeout(s),l!=window.innerWidth&&(console.log("resizing"),l=window.innerWidth,s=setTimeout(function(){for(var e=0;e<c.length;e++){var t=document.getElementById(c[e].sectionID).getElementsByClassName("qq-marquee-images"),n=t.length;if(1<n)for(var i=n-1;0<i;i--)t[i]&&t[i].remove();t[0].parentNode.classList.remove("qq-animate"),r(c[e])}},500))}}()}window.addEventListener("shopify:section:load",function(e){t()}),t(),"loading"!==document.readyState?n():document.addEventListener("DOMContentLoaded",function(){n()}),window.addEventListener("shopify:section:load",function(e){n()})}();
  } catch(e) { console.error(e); }
})();
})();
